// translations/pages/events/nl.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageNL = {
  title: 'Evenementen',
  upcoming: 'Komende evenementen',
  past: 'Afgelopen evenementen',
  all: 'Alle evenementen',
  items: {
    wikki26: {
      title: 'WiKKI26 – Wildau-conferentie over kunstmatige intelligentie',
      description: 'pAIoneer Labs was als exposant aanwezig op de Technische Hochschule Wildau. Op de stand ging het over de vraag hoe lokale AI-infrastructuren in bedrijven en organisaties worden opgebouwd: datasoevereiniteit, privacy by design en AI die aan wet- en regelgeving voldoet, zonder onnodige afhankelijkheid van externe cloudoplossingen.'
    }
  }
};
